// Switch to true to show the LUXEWELL Experiences site links.
export const SHOW_EXPERIENCES_SITE = false;
export const EXPERIENCES_SITE = "https://luxewellexperiences.com";

export const MANTRA = "Balanced Wellbeing is the Ultimate\u00a0Luxury.";
export const FLOURISH = "Human flourishing fuels humanity flourishing.";

const TERMS = ["Strategic Sabbaticals™", "Strategic Sabbatical™", "Regenerative Retreats™", "Regenerative Retreat™", "Wellness Weddings™", "Villa Vitality™", "Yacht Yoga™", "Mental Fitness Focus Training™", "Leverage Wellness™"];
const RE = new RegExp(`(${TERMS.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "g");

// Renders text with signature terms set slightly italic.
export const Sig = ({ children }) => {
  if (typeof children !== "string") return children;
  return children.split(RE).map((part, i) => (TERMS.includes(part) ? <em key={i} className="italic">{part.slice(0, -1)}<sup className="text-[0.5em] not-italic">™</sup></em> : part));
};

export const MethodEyebrow = ({ className = "" }) => (
  <p className={`eyebrow !text-[0.58rem] !text-gold ${className}`} data-testid="method-eyebrow">The LUXEWELL Define · Design · Deliver Method</p>
);

export function BrandStack({ className = "text-ink/85", testid = "brand-stack", line2 }) {
  return (
    <div className={`font-headline italic text-2xl sm:text-3xl lg:text-4xl leading-tight ${className}`} data-testid={testid}>
      <p>{MANTRA}</p>
      <p className="mt-1">{line2 || <>Live Luxuriously. Inside Out.<sup className="text-[0.45em] not-italic">™</sup></>}</p>
    </div>
  );
}

export function ClosingLine({ className = "" }) {
  return (
    <p className={`font-headline italic text-2xl sm:text-3xl lg:text-4xl text-gold leading-tight ${className}`} data-testid="closing-line">
      You Define. We Design. Your Luxury.
    </p>
  );
}
